$           = require('jquery');
var angular = require('angular');
var _       = require('lodash');
var _module = angular.module('listreports.main-menu', []);
var ConfettiGenerator = require('confetti-js');

require('angular-animate');
require('ng-dialog');
require('slick-carousel');
require('angular-slick');
require('angularyoutube');
require('../core/mark-active');
require('../core/fullscreen-image');
require('../core/fullscreen-gallery');
require('../core/slick-gallery-item-clicked');
require('../core/utils');
require('../core/filters');
require('../core/fill-height');
require('../cached-templates/templates');
require('../modals/lead-form');
require('../modals/realtor-slide');
require('../modals/lender-slide');
require('../modals/about-slide');
require('../modals/compliance-slide');
require('../modals/get-financed');
require('../modals/local-housing-market');
require('../modals/local-housing-market-stats');
require('../modals/mortgage-calculator');
require('../modals/mortgage-calculator-service');
require('../modals/area-map/controller');
require('../slick-sync');
require('../events');
require('angular-sanitize');
require('../../libs/pendo');
require('angular-google-maps');


_module.requires.push(
    'ngAnimate',
    'ngSanitize',
    'ngDialog',
    'angular-slick',
    'youtube-embed',
    'listreports.core',
    'templates',
    'listreports.modals',
    'angular-slick.sync',
    'listreports.events',
    'pendolytics',
    'uiGmapgoogle-maps'
);
_module.filter('unique', function() {
    return function (collection, field) {
        return _.uniq(collection, field);
    };
});
_module.factory('contactHelpOptions', function(){
    function getLenderHelp(){
        return [
            {name:'Getting pre-approved'},
            {name: 'Learning about home purchase options'}
        ];
    }
    function getRealtorHelp(){
        return [
            {name:'Buying a new home'},
            {name: 'Selling my current property'}
        ];
    }
    return {
        getLenderHelp: getLenderHelp,
        getRealtorHelp: getRealtorHelp
    };
});
_module
    .controller('MainMenuController', [
        '$log',
        '$scope',
        '$rootScope',
        '$compile',
        '$utils',
        'ngDialog',
        '$events',
        '$location',
        '$window',
        '$pendolytics',
        'contactHelpOptions',
        'sliderConfig',
        '$timeout',
        '$fairHousingConfigStore',
        '$stateParams',

        function($log, $scope, $rootScope, $compile, $utils, ngDialog, $events, $location, $window, $pendolytics, contactHelpOptions, sliderConfig, $timeout, $fairHousingConfigStore, $stateParams) {

            $scope.pageMoving = false;
            $scope.skin = $stateParams.skin;
            $scope.copyrightYear = new Date().getFullYear();
            $scope.nestUrl = "https://nest.me";
            $scope.demo = ($location.search().demo || '').toLowerCase() === 'true' ? true : false;
            $scope.hidePremiumBottomBanner = $scope.isMobile && $utils.isInIframe();
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());

            if(params.hasOwnProperty('unpair')){
                $scope.agenteUnpair = params.unpair === 'true';
            }

            $scope.indexes = {
                exploreTheAreaIndex: 0,
                enhancedGalleryIndex: 0,
                meetYourLenderIndex: 0,
                meetYourRealtorIndex: 0,
                aboutTheHomeIndex: 0
            };

            const listingState = (_.get($scope, 'report.addressParts.state') || '').toLowerCase();
            $fairHousingConfigStore.then(function(complianceObj) {
                $scope.fairHousingCompliance = complianceObj && complianceObj[listingState] ?
                    complianceObj[listingState].compliance_url :
                    null;
            });

            $window.ontouchmove = function(e){
                $scope.pageMoving = true;
            }

            $window.ontouchend = function(e){
                $scope.pageMoving = false;
            }

            $scope.sliderConfig = sliderConfig;

            $scope.cardsResponsiveBreakpoints = [
                {
                    breakpoint: 1100,
                    settings: {
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 1441,
                    settings: {
                        centerPadding: '250px'
                    }
                },
                {
                    breakpoint: 1921,
                    settings: {
                        centerPadding: '450px'
                    }
                }
            ];

            $scope.fullscreenImage = null;

            $scope.exploreTheAreaImages = [
                $scope.report.images.area.default,
                $scope.report.images.outdoors.default,
            ];

            if(_.get($scope, 'report.images.restaurant.default')) {
                try {
                    if(!$scope.report.meta.hide_restaurants)
                        $scope.exploreTheAreaImages.push($scope.report.images.restaurant.default);
                } catch (err) {
                    $scope.exploreTheAreaImages.push($scope.report.images.restaurant.default);
                }
            }

            if(_.get($scope, 'report.images.schools.default')) {
                try {
                    if(!$scope.report.meta.hide_schools)
                        $scope.exploreTheAreaImages.push($scope.report.images.schools.default);
                } catch (err) {
                    $scope.exploreTheAreaImages.push($scope.report.images.schools.default);
                }
            }

            $scope.galleryImages = $scope.report.images.enhanced_gallery.concat($scope.exploreTheAreaImages);

            $scope.showExploreTheArea   = false;
            $scope.showEnhancedGallery  = false;
            $scope.showAboutTheHome     = false;
            $scope.showGetFinanced      = false;
            $scope.showMeetYourRealtor  = false;
            $scope.showMeetYourLender   = false;
            $scope.showRealtorContactUs = false;
            $scope.showOpenHouseInfo    = false;
            $scope.showAreaMap          = false;
            $scope.showLocalHousingMarket = false;
            $scope.showFallbackShare    = false;
            $scope.isSold               = $location.search().sold === 'true';
            $scope.contactHelpOptions = [];
            $scope.companyTypeMap = {
                Mortgage: {
                    icon: 'fa-2x lr-dollar-briefcase-o',
                    leadForm: {
                        title: 'Financing<br>Info',
                        modalTitle: 'Payment Calculator'
                    },
                    meetYourTitle: 'Meet Your Lender',
                    meetYourTitleMenu: 'Meet your<br> loan officer'
                },
                Escrow: {
                    icon: 'fa-2x lr-dollar-o-alt',
                    leadForm: false,
                    meetYourTitle: 'Meet Your Escrow Officer',
                    meetYourTitleMenu: 'Meet your<br> escrow officer'
                },
                Insurance: {
                    icon: 'ls-icon-shield',
                    leadForm: {
                        title: 'Get<br>a Quote',
                        modalTitle: 'Get a Quote'
                    },
                    meetYourTitle: 'Meet Your Insurance Agent',
                    meetYourTitleMenu: 'Meet your<br> insurance agent'
                },
                Other: {
                    icon: 'fa-2x lr-partner-o',
                    leadForm: false,
                    meetYourTitle: 'Meet Your Partner',
                    meetYourTitleMenu: 'Meet your<br> partner'
                },
                Title: {
                    icon: 'fa-2x lr-title-o',
                    leadForm: false,
                    meetYourTitle: 'Meet Your Title Rep',
                    meetYourTitleMenu: 'Meet your<br> title rep'
                },
            };
            $scope.companyType = $scope.report.comarketer.company_type || 'Mortgage';

            var date = new Date();
            $scope.shareUrl = $location.absUrl() + ((/\?/).test($location.absUrl()) ? '&' : '?') + 'v=' + date.getTime();
            $scope.encodedShareUrl = encodeURIComponent($scope.shareUrl);

            // Trigger Pendo if demo true
            try {
                $pendolytics.identify({
                    visitor: {
                        id: 'VISITOR-UNIQUE-ID',   // Required if user is logged in
                        demo: $scope.demo
                    },

                    account: {}
                });

                if($scope.demo) {
                    setTimeout(function () {
                        pendo.showGuideByName('Prop Website - Offer Banner');
                    }, 1000);
                }
            } catch (err) {
                $log.error('Pendo Error', err);
            }

            /**
             * Follow+ Just Sold Confetti
             */
            if($scope.isSold) {
                renderConfetti();

                var confetti;
                var rerenderTimeout;

                $window.addEventListener('resize', function (e) {
                    if(confetti) {
                        confetti.clear();
                        confetti = undefined;
                    }

                    if(rerenderTimeout) $timeout.cancel(rerenderTimeout);
                    rerenderTimeout = $timeout(renderConfetti, 100);
                });

                function renderConfetti() {
                    confetti = new ConfettiGenerator({
                        target: 'confetti',
                        max: '500',
                        size: '1',
                        animate: true,
                        props: ['square', 'triangle', 'line', {
                            'type': 'svg',
                            'src': 'https://design.listreports.com/spw/ListReports-Icon.svg',
                            'size': 15,
                            'weight': 0.1
                        }],
                        colors: [
                            [213, 29, 76],
                            [243, 178, 4],
                            [14, 189, 200],
                            [140, 182, 63]
                        ],
                        clock: '25',
                        rotate: false,
                    });
                    confetti.render();
                }
            }

            $scope.isAnyCardShowing = function(){
                return $scope.showAboutTheHome || $scope.showEnhancedGallery
                || $scope.showExploreTheArea || $scope.showGetFinanced
                || $scope.showGuideByName || $scope.showMeetYourLender
                || $scope.showMeetYourRealtor || $scope.showOpenHouseInfo || $scope.showRealtorContactUs || $scope.showFallbackShare;
            }
            // $scope Functions
            $scope.openAbouttheHome = function() {
                if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                    $scope.showAboutTheHome = true;
                    $events.track('Box Click', {
                        'Source': 'About the Home'
                    });
                }
            };

            $scope.openExploreTheArea = function() {
                if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                    $scope.showExploreTheArea = true;
                    $events.track('Box Click', {
                        'Source': 'Explore The Area'
                    });
                }
            };

            $scope.viewEnhancedGallery = function() {
                if(!$scope.pageMoving && (!$scope.isAnyCardShowing() || $scope.showAboutTheHome)){
                    $scope.showAboutTheHome = false;
                    $scope.showEnhancedGallery = true;
                    $events.track('About The Home View Gallery Click', {
                        'Source': 'Image / Text Link'
                    });
                }
            };

            $scope.openEnhancedGallery = function() {
                if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                    $scope.showEnhancedGallery = true;
                    $events.track('Box Click', {
                        'Source': 'Photo Gallery'
                    });
                }
            };

            $scope.openGetFinanced = function() {
                if(!$scope.pageMoving && !$scope.isAnyCardShowing()){

                    var mixPanelSource;

                    if ($scope.report.comarketer.get_financed) {
                        mixPanelSource = 'Get Financed - ' + $scope.report.comarketer.get_financed;
                        $window.open($scope.report.comarketer.get_financed, '_blank');
                    } else {
                        $scope.showGetFinanced = true;
                        mixPanelSource = $scope.companyTypeMap[$scope.companyType].leadForm.modalTitle;
                    }

                    $events.track('Box Click', {
                        'Source': mixPanelSource
                    });

                    window.report = $scope.report;

                }
            };

            $scope.openMeetYourRealtor = function() {
                if(!$scope.pageMoving){
                    $scope.showMeetYourRealtor = true;
                    $scope.contactHelpOptions = contactHelpOptions.getRealtorHelp();
                    $events.track('Box Click', {
                        'Source': 'Meet Your Realtor'
                    });
                }
            };


            $scope.openMeetYourPartner = function() {
                if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                    $scope.showMeetYourLender = true;
                    $scope.contactHelpOptions = contactHelpOptions.getLenderHelp();
                    $events.track('Box Click', {
                        'Source': $scope.companyTypeMap[$scope.companyType].meetYourTitle
                    });
                }
            };

            $scope.openLocalHousingMarket = function() {
                if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                    $scope.showLocalHousingMarket = true;
                    $events.track('Box Click', {
                        'Source': 'Local Housing Market'
                    });
                }
            };


            $scope.openRealtorContactUs = function() {
                if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                    $scope.showRealtorContactUs = true;
                    $events.track('Box Click', {
                        'Source': 'Realtor Contact Us'
                    });
                }
            };


            $scope.openOpenHouseInfo = function() {
                if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                    $scope.showOpenHouseInfo = true;
                    $events.track('Open House Info Click', {
                        'Source': 'Open House Info'
                    });
                }
            };

            $scope.openAreaMap = function() {
                $scope.showAreaMap = true;
                $events.track('Box Click', {
                    'Source': 'Area Map'
                });
            };

            $scope.closeOpenHouseInfo = function() {
                if(!$scope.pageMoving){
                    $scope.showOpenHouseInfo = false;
                    $events.track('Close House Info Click', {
                        'Source': 'Close House Info'
                    });
                }
            };


            $scope.showFullscreenGallery = function(gallery, galleryIndexName, itemIndex, source) {
                if(!$scope.pageMoving){
                    if($scope.indexes[galleryIndexName] === itemIndex) {
                        $scope[gallery] = true;
                        $events.track('Full-Screen Click', {
                            'Source': source
                        });
                    } else {
                        $scope.indexes[galleryIndexName] = itemIndex;
                    }
                }
            };

            $scope.setEnhancedGalleryIndex = function(index) {
                $scope.indexes.enhancedGalleryIndex = index;
            };

            $scope.closeGetFinanced = function() {
                $scope.showGetFinanced = false;
            };

            $scope.trackSimilarHomesClick = function trackSimilarHomesClick() {
                if(!$scope.pageMoving){
                    $events.track('spw_similar_homes_button_click');
                }
            };

            $scope.trackClickEvent = function trackClickEvent(eventName, eventData) {
                if(!$scope.pageMoving){
                    $events.track(eventName, eventData);
                }
            };

            $scope.openFallbackShareDialog = function () {
                $scope.showFallbackShare = true;
            };

            $scope.copyToClipboard = function () {
                var el = document.getElementById('copy-link-input');
                $scope.trackClickEvent('spw_share_button_option_click', { source: 'Copy Link' });
                if(el) {
                    el.select();
                    document.execCommand('copy');
                    if (window.getSelection) {window.getSelection().removeAllRanges();}
                }
            }

            $scope.onFacebookShare = function onFacebookShare() {
                var windowFeatures = $scope.isMobile ? null : 'width=555,height=745';
                $window.open('https://www.facebook.com/sharer.php?u=' + $scope.encodedShareUrl, '_blank', windowFeatures);
                $scope.trackClickEvent('spw_share_button_option_click', { source: 'Facebook' });
            }

            $scope.onTwitterShare = function onTwitterShare() {
                $window.open('https://twitter.com/intent/tweet?url=' + $scope.encodedShareUrl);
                $scope.trackClickEvent('spw_share_button_option_click', { source: 'Twitter' });
            }

            $scope.onLinkedInShare = function onLinkedInShare() {
                var windowFeatures = $scope.isMobile ? null : 'width=490,height=600';
                $window.open('https://www.linkedin.com/shareArticle?url=' + $scope.encodedShareUrl, '_blank', windowFeatures);
                $scope.trackClickEvent('spw_share_button_option_click', { source: 'LinkedIn' });
            }

            $scope.handleShareClick = function () {
                var openFallbackShareDialog = $scope.openFallbackShareDialog;
                var shareTitle = $scope.report.display_address || $scope.report.address;
                $utils.showWebShare($scope.shareUrl, shareTitle, openFallbackShareDialog);
                $scope.trackClickEvent('spw_share_button_click');
            }

            $scope.displayAsLocalTime = function (dateString) {
                var t = dateString;
                if(dateString) {
                    t = new Date(dateString);
                    t = new Date( t.getTime() + ( t.getTimezoneOffset() * 60000 ) );
                }

                return t;
            };

        }
    ])
;


module.exports = _module;
